/* unplugin-vue-components disabled */import { render } from "./ScoreChart.vue?vue&type=template&id=1e6d920a&scoped=true"
import script from "./ScoreChart.vue?vue&type=script&lang=js"
export * from "./ScoreChart.vue?vue&type=script&lang=js"

import "./ScoreChart.vue?vue&type=style&index=0&id=1e6d920a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6d920a"]])

export default __exports__